import script from "./sf-indicator-count.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-indicator-count.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__